import { render, staticRenderFns } from "./VipCardFeePrivacyManage.vue?vue&type=template&id=101613f8"
import script from "./VipCardFeePrivacyManage.vue?vue&type=script&lang=js"
export * from "./VipCardFeePrivacyManage.vue?vue&type=script&lang=js"
import style0 from "./VipCardFeePrivacyManage.vue?vue&type=style&index=0&id=101613f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports